export enum ProfileCreationTrackingEvents {
    PROFILE_CREATION_STARTED = 'profile_creation_started',
    PROFILE_CREATED = 'profile_created',
}
